import flame from "./Fire.png";
import asian from "./asian.png";
import barbeque from "./barbeque.png";
import drinks from "./drinks.png";
import goan from "./goan.png";
import salad from "./salad.png";
import ice from "./ice.png";
import King from "./king.png";
import Buffet from "./buffet.png";
import bar from "./bar.png";
import diet from "./diet.png";
import chef from "./chef.png";
import menupointer from "./menu-pointer.png";
import menupointerdeactive from "./menu-pointer-deactive.png";
import trucktick from './truck-tick.png';
import fb from './fb.png'
import git from './git.png'
import herobanner from './herobanner.png'
import insta from './insta.png'
import logofooter from './logo_footer.png'
import newlogo from './new_logo.png'
import twitter from './twitter.png'
import foods from './foods.png'
import egg from './egg.png'
import fries from './fries.png'
import pancakes from './pancakes.png'
import masalafries from './masalafries.png'
import Rectangle8 from './Rectangle 8.png'
import Vector3 from './Vector 3.png'
import Customer1 from './Customer1.png'
import Customer2 from './Customer2.png'
import Customer3 from './Customer3.png'

export const symbols={
  flame,
  chef,
  menupointer,
  menupointerdeactive,
  trucktick,
  fb,
  git,
  insta,
  twitter,
  newlogo,
  herobanner,
  logofooter,
  foods,
  Rectangle8,
  Vector3
}

export const food = {
  egg,
  fries,
  pancakes,
  masalafries,
}

export const customer={
  Customer1,
  Customer2,
  Customer3
}



export const assets = [

    {
      name:"Asian",
      image: asian,
      description: "used as pointer",
    },{
      name:"Barbeque",
      image: barbeque,
      description: "used as pointer",
    },{
      name:"Drinks",
      image: drinks,
      description: "used as pointer",
    },{
      name:"Goan",
      image: goan,
      description: "used as pointer",
    },{
      name:"Ice-cream",
      image: ice,
      description: "used as pointer",
    },{
      name:"Salad",
      image: salad,
      description: "used as pointer",
    }
]
export const services=[
  {
    name:"All King of Events",
    image: King,
    description: "In the new era of technology we look in the future with certainty for life.",
  },
  {
    name:"Buffet Service",
    image: Buffet,
    description: "In the new era of technology we look in the future with certainty for life.",
  },
  {
    name:"Bar Services",
    image: bar,
    description: "In the new era of technology we look in the future with certainty for life.",
  },
  {
    name:"Special Dietary Needs",
    image: diet,
    description: "uIn the new era of technology we look in the future with certainty for life.sed as pointer",
  }
]